import { initContract } from '@ts-rest/core';
import { authPlayerContract } from './player.auth.contract';
import { adminPlayerContract } from './player.admin.contract';

const c = initContract();

export const playerContract = c.router(
  {
    auth: authPlayerContract,
    admin: adminPlayerContract,
  },
  {
    pathPrefix: '/player',
    strictStatusCodes: true,
  }
);

export * from './player.auth.contract';
export * from './player.admin.contract';
